/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".label-container[_ngcontent-%COMP%] {\r\n    height: 100%;\r\n    \r\n}"];
export { styles as styles };
